<template>
  <MountingTimeslots :model-value="modelValue" variant="closed" />
</template>

<script lang="tsx" setup>
import { type Mounting } from "@/entities/Entities";

import MountingTimeslots from "@pages/mountings/mounting/MountingTimeslots.vue";

interface Props {
  modelValue: Mounting | null;
}
defineProps<Props>();
</script>

<style lang="scss" scoped>
</style>
